<template>
  <div class="v-tabs" ref="input">
    <div class="v-tabs-body">
      <div class="v-tabs-tab" :class="{active:t[tabValue]==value}" v-for="(t,i) in list" :key="i" ref="tabs">
        <slot name="tab" :tab="t" v-if="'tab' in $scopedSlots"/>
        <div class="v-tabs-tab-inner" v-else>{{t[tabLabel]}}</div>
      </div>
    </div>
    <div class="v-tabs-foot">
      <slot name="slider" :slider="sliderStyle" :tab="tab" v-if="'slider' in $scopedSlots"/>
      <div class="v-tabs-slider" :style="{width:`${sliderStyle.width}px`,transform:`translate3d(${sliderStyle.left}px,0,0)`}" v-else></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 0
    },
    tabs: {
      default() {
        return [];
      }
    },
    tabLabel: {
      default: "label"
    },
    tabValue: {
      default: "value"
    },
    trigger: {
      default: "click",
      validator(v) {
        return ["click", "hover"].includes(v);
      }
    }
  },
  data() {
    return {
      sliderStyle: {}
    };
  },
  computed: {
    list() {
      return this.tabs.map(
        (t, v) =>
          t instanceof Object ? t : { [this.tabLabel]: t, [this.tabValue]: v }
      );
    },
    tab() {
      return this.list.filter(t => t[this.tabValue] === this.value)[0];
    }
  },
  watch: {
    ["value"]() {
      this.change(this.tab);
    }
  },
  methods: {
    select(t) {
      this.$emit("input", t[this.tabValue]);
    },
    change(t) {
      this.$emit("change", t);
      let tab = this.$refs.tabs[this.list.indexOf(t)];
      this.sliderStyle = tab
        ? { left: tab.offsetLeft, width: tab.offsetWidth }
        : { left: 0, width: 0 };
      tab && tab.scrollIntoViewIfNeeded();
    }
  },
  mounted() {
    this.$refs.tabs.forEach((t, i) => {
      t.addEventListener(
        {
          click: "click",
          hover: "mouseover"
        }[this.trigger],
        e => {
          this.select(this.list[i]), e.stopPropagation();
        }
      );
    });
    this.change(this.tab);
  }
};
</script>

<style lang="less">
.v-tabs {
  position: relative;
  box-sizing: border-box;
  background-color: #ffffff;
  > .v-tabs-body {
    display: flex;
    white-space: nowrap;
    > .v-tabs-tab {
      display: flex;
      cursor: pointer;
      color: #666666;
      &.active {
        color: #41b883;
      }
      > .v-tabs-tab-inner {
        padding: 0px 10px;
        line-height: 32px;
      }
    }
  }
  > .v-tabs-foot {
    position: relative;
    > .v-tabs-slider {
      bottom: 0px;
      min-height: 2px;
      position: absolute;
      visibility: hidden;
      background-color: #41b883;
      transition: 300ms;
    }
  }
  &[slider] {
    > .v-tabs-foot {
      > .v-tabs-slider {
        visibility: visible;
      }
    }
  }
  &[type="space-around"] {
    > .v-tabs-body {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/tabs.vue